"use strict";

function createCommonjsModule(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}
function baseToString(e) {
  if ("string" == typeof e) return e;
  if (isSymbol(e)) return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY ? "-0" : t;
}
function isObjectLike(e) {
  return !!e && "object" == typeof e;
}
function isSymbol(e) {
  return "symbol" == typeof e || isObjectLike(e) && objectToString.call(e) == symbolTag;
}
function toString(e) {
  return null == e ? "" : baseToString(e);
}
function uniqueId(e) {
  var t = ++idCounter;
  return toString(e) + t;
}
function setupGridValues(e) {
  for (var t = [], n = 1; n < e + 1; n++) t.push((n / e * 100).toFixed(2) + "%");
  return t;
}
function createColumns(e) {
  var t = {};
  return e.forEach(function (e, n) {
    return t["col" + (n + 1)] = {
      width: e
    };
  }), t;
}
function addBreakpoints(e, t, n) {
  Object.keys(breakpoints).forEach(function (r) {
    for (var o = 0; o < t; o++) {
      var i = {};
      i[breakpoints[r]] = {
        width: n[o]
      }, e[r + "Col" + (o + 1)] = i;
    }
  });
}
function hyphenateStyleName(e) {
  return e in cache$1 ? cache$1[e] : cache$1[e] = e.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
}
var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  keys = createCommonjsModule(function (e, t) {
    function n(e) {
      var t = [];
      for (var n in e) t.push(n);
      return t;
    }
    t = e.exports = "function" == typeof Object.keys ? Object.keys : n, t.shim = n;
  }),
  is_arguments = createCommonjsModule(function (e, t) {
    function n(e) {
      return "[object Arguments]" == Object.prototype.toString.call(e);
    }
    function r(e) {
      return e && "object" == typeof e && "number" == typeof e.length && Object.prototype.hasOwnProperty.call(e, "callee") && !Object.prototype.propertyIsEnumerable.call(e, "callee") || !1;
    }
    var o = "[object Arguments]" == function () {
      return Object.prototype.toString.call(arguments);
    }();
    t = e.exports = o ? n : r, t.supported = n, t.unsupported = r;
  }),
  index = createCommonjsModule(function (e) {
    function t(e) {
      return null === e || void 0 === e;
    }
    function n(e) {
      return !(!e || "object" != typeof e || "number" != typeof e.length) && "function" == typeof e.copy && "function" == typeof e.slice && !(e.length > 0 && "number" != typeof e[0]);
    }
    function r(e, r, u) {
      var f, c;
      if (t(e) || t(r)) return !1;
      if (e.prototype !== r.prototype) return !1;
      if (a(e)) return !!a(r) && (e = o.call(e), r = o.call(r), l(e, r, u));
      if (n(e)) {
        if (!n(r)) return !1;
        if (e.length !== r.length) return !1;
        for (f = 0; f < e.length; f++) if (e[f] !== r[f]) return !1;
        return !0;
      }
      try {
        var s = i(e),
          d = i(r);
      } catch (e) {
        return !1;
      }
      if (s.length != d.length) return !1;
      for (s.sort(), d.sort(), f = s.length - 1; f >= 0; f--) if (s[f] != d[f]) return !1;
      for (f = s.length - 1; f >= 0; f--) if (c = s[f], !l(e[c], r[c], u)) return !1;
      return typeof e == typeof r;
    }
    var o = Array.prototype.slice,
      i = keys,
      a = is_arguments,
      l = e.exports = function (e, t, n) {
        return n || (n = {}), e === t || (e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : !e || !t || "object" != typeof e && "object" != typeof t ? n.strict ? e === t : e == t : r(e, t, n));
      };
  }),
  INFINITY = 1 / 0,
  symbolTag = "[object Symbol]",
  freeGlobal = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
  freeSelf = "object" == typeof self && self && self.Object === Object && self,
  root = freeGlobal || freeSelf || Function("return this")(),
  objectProto = Object.prototype,
  idCounter = 0,
  objectToString = objectProto.toString,
  Symbol$1 = root.Symbol,
  symbolProto = Symbol$1 ? Symbol$1.prototype : void 0,
  symbolToString = symbolProto ? symbolProto.toString : void 0,
  index$1 = uniqueId,
  kebabCase = function kebabCase(e) {
    return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  },
  camelCase = function camelCase(e) {
    return e.replace(/-([a-z])/g, function (e, t) {
      return t.toUpperCase();
    });
  },
  capitalize = function capitalize(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  },
  isArray = function isArray(e) {
    return e.constructor === Array;
  },
  convertToKebabCase = function convertToKebabCase(e) {
    return e.startsWith("@keyframes") ? e : (/[A-Z]/.test(e[0]) ? "-" + kebabCase(e) : kebabCase(e)).replace(/\[(.+?)\]/g, function (e) {
      return camelCase(e);
    });
  },
  createSheet = function createSheet(e) {
    var t = document.getElementById(e);
    if (t) return t.sheet;
    var n = document.createElement("style");
    return n.setAttribute("id", e), document.head.appendChild(n), n.sheet;
  },
  _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  defineProperty = function defineProperty(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  },
  _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  },
  get = function e(t, n, r) {
    null === t && (t = Function.prototype);
    var o = Object.getOwnPropertyDescriptor(t, n);
    if (void 0 === o) {
      var i = Object.getPrototypeOf(t);
      return null === i ? void 0 : e(i, n, r);
    }
    if ("value" in o) return o.value;
    var a = o.get;
    if (void 0 !== a) return a.call(r);
  },
  set = function e(t, n, r, o) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    if (void 0 === i) {
      var a = Object.getPrototypeOf(t);
      null !== a && e(a, n, r, o);
    } else if ("value" in i && i.writable) i.value = r;else {
      var l = i.set;
      void 0 !== l && l.call(o, r);
    }
    return r;
  },
  defaultColors = {
    white: "#ffffff",
    navy: "#001f3f",
    blue: "#0074D9",
    aqua: "#7FDBFF",
    teal: "#39CCCC",
    olive: "#3D9970",
    green: "#2ECC40",
    lime: "#01FF70",
    yellow: "#FFDC00",
    orange: "#FF851B",
    red: "#FF4136",
    maroon: "#85144b",
    fuchsia: "#F012BE",
    purple: "#B10DC9",
    black: "#111111",
    gray: "#AAAAAA",
    silver: "#DDDDDD"
  },
  buildColors = function buildColors(e) {
    var t = _extends({}, defaultColors, e ? e.colors : {});
    return Object.keys(t).reduce(function (e, n) {
      var r;
      return _extends({}, e, (r = {}, defineProperty(r, n, {
        color: t[n]
      }), defineProperty(r, "hover" + capitalize(n), {
        ":hover": {
          color: t[n]
        }
      }), defineProperty(r, "bg" + capitalize(n), {
        backgroundColor: t[n]
      }), defineProperty(r, "border" + capitalize(n), {
        borderColor: t[n]
      }), defineProperty(r, "stroke" + capitalize(n), {
        stroke: t[n]
      }), defineProperty(r, "fill" + capitalize(n), {
        fill: t[n]
      }), r));
    }, {});
  },
  defaultScale = [0, .5, 1, 1.5, 2, 4, 8],
  buildWhitespace = function buildWhitespace(e) {
    var t = 0,
      n = {},
      r = e && e.scale ? e.scale : defaultScale;
    for (r = r.map(function (e) {
      return e + "rem";
    }); t < r.length;) n["p" + t] = {
      padding: r[t]
    }, n["pt" + t] = {
      paddingTop: r[t]
    }, n["pb" + t] = {
      paddingBottom: r[t]
    }, n["pl" + t] = {
      paddingLeft: r[t]
    }, n["pr" + t] = {
      paddingRight: r[t]
    }, n["px" + t] = {
      paddingRight: r[t],
      paddingLeft: r[t]
    }, n["py" + t] = {
      paddingTop: r[t],
      paddingBottom: r[t]
    }, n["m" + t] = {
      margin: r[t]
    }, n["mt" + t] = {
      marginTop: r[t]
    }, n["mb" + t] = {
      marginBottom: r[t]
    }, n["ml" + t] = {
      marginLeft: r[t]
    }, n["mr" + t] = {
      marginRight: r[t]
    }, n["mx" + t] = {
      marginRight: r[t],
      marginLeft: r[t]
    }, n["my" + t] = {
      marginTop: r[t],
      marginBottom: r[t]
    }, t > 0 && (n["mxn" + t] = {
      marginRight: "-" + r[t],
      marginLeft: "-" + r[t]
    }), t++;
    return n.mlAuto = {
      marginLeft: "auto"
    }, n.mrAuto = {
      marginRight: "auto"
    }, n.mxAuto = {
      marginRight: "auto",
      marginLeft: "auto"
    }, n;
  },
  buildTypography = function buildTypography() {
    var e = {};
    return e.h0 = {
      fontSize: "4rem"
    }, e.h1 = {
      fontSize: "2rem"
    }, e.h2 = {
      fontSize: "1.5rem"
    }, e.h3 = {
      fontSize: "1.25rem"
    }, e.h4 = {
      fontSize: "1rem"
    }, e.h5 = {
      fontSize: "0.875rem"
    }, e.h6 = {
      fontSize: "0.75rem"
    }, e.bold = {
      fontWeight: "bold"
    }, e.normal = {
      fontWeight: "normal"
    }, e.italic = {
      fontStyle: "italic"
    }, e.caps = {
      textTransform: "uppercase"
    }, e.center = {
      textAlign: "center"
    }, e.leftAlign = {
      textAlign: "left"
    }, e.rightAlign = {
      textAlign: "right"
    }, e.justify = {
      textAlign: "justify"
    }, e.noWrap = {
      whiteSpace: "nowrap"
    }, e.underline = {
      textDecoration: "underline"
    }, e.noUnderline = {
      textDecoration: "none"
    }, e.trackedOut = {
      letterSpacing: "0.1em"
    }, e.listReset = {
      listStyle: "none",
      paddingLeft: "0px"
    }, e;
  },
  buildPositioning = function buildPositioning() {
    var e = {};
    return e.fixed = {
      position: "fixed",
      willChange: "transform"
    }, e.relative = {
      position: "relative"
    }, e.absolute = {
      position: "absolute"
    }, e.top0 = {
      top: 0
    }, e.left0 = {
      left: 0
    }, e.bottom0 = {
      bottom: 0
    }, e.right0 = {
      right: 0
    }, e.z1 = {
      zIndex: 1
    }, e.z2 = {
      zIndex: 2
    }, e.z3 = {
      zIndex: 3
    }, e.z4 = {
      zIndex: 4
    }, e;
  },
  buildLayout = function buildLayout() {
    var e = {};
    return e.table = {
      display: "table",
      width: "100%"
    }, e.tableCell = {
      display: "table-cell",
      verticalAlign: "middle"
    }, e.tableRow = {
      display: "table-row"
    }, e.inline = {
      display: "inline"
    }, e.block = {
      display: "block"
    }, e.inlineBlock = {
      display: "inline-block"
    }, e.alignTop = {
      verticalAlign: "top"
    }, e.alignMiddle = {
      verticalAlign: "middle"
    }, e.alignBottom = {
      verticalAlign: "bottom"
    }, e.alignBaseline = {
      verticalAlign: "baseline"
    }, e.overflowHidden = {
      overflow: "hidden"
    }, e.overflowAuto = {
      overflow: "auto"
    }, e.overflowScroll = {
      overflow: "scroll"
    }, e.right = {
      float: "right"
    }, e.left = {
      float: "left"
    }, e.clearfix = {
      ":before": {
        content: '" "',
        display: "table"
      },
      ":after": {
        content: '" "',
        display: "table",
        clear: "both"
      }
    }, e;
  },
  breakpoints = {
    sm: "@media (min-width: 40em)",
    md: "@media (min-width: 52em)",
    lg: "@media (min-width: 64em)",
    xl: "@media (min-width: 76em)",
    xx: "@media (min-width: 88em)"
  },
  buildGrid = function buildGrid(e) {
    var t = e && e.columns ? e.columns : 12,
      n = setupGridValues(t),
      r = createColumns(n);
    return addBreakpoints(r, t, n), r;
  },
  buildComposes = function buildComposes(e) {
    return _extends({}, buildColors(e), buildWhitespace(e), buildGrid(e), buildPositioning(), buildTypography(), buildLayout());
  },
  composes = buildComposes(),
  config = buildComposes,
  joinDeclarations = function joinDeclarations(e) {
    return e.filter(function (e) {
      return "object" !== _typeof(e.value);
    }).map(function (e) {
      return e.key + ": " + e.value;
    }).join(";");
  },
  buildRule = function buildRule(e, t) {
    if (e.key.startsWith(":")) return {
      classname: "" + t + e.key,
      rule: "." + t + e.key + " { " + joinDeclarations(e.value) + "; }"
    };
    if (e.key.startsWith("@media")) return {
      classname: "" + t,
      rule: e.key + " { ." + t + " { " + joinDeclarations(e.value) + " } }"
    };
    if (e.key.startsWith("@keyframes")) {
      var n = e.value.map(function (e) {
        return e.key + " { " + joinDeclarations(e.value) + "; }";
      }).join(" ");
      return {
        classname: "" + e.key,
        rule: e.key + " { " + n + " }"
      };
    }
    return {
      classname: t + " " + e.key,
      rule: "." + t + " " + e.key + " { " + joinDeclarations(e.value) + "; }"
    };
  },
  attachRule = function attachRule(e, t) {
    if ("undefined" != typeof document) try {
      t.insertRule(e, t.cssRules.length);
    } catch (t) {
      console.warn("Vudu: Failed to insert rule:", e, t);
    }
  },
  addRule = function e(t, n, r, o) {
    var i = joinDeclarations(t);
    o && i.length && attachRule("." + n + " { " + i + "; }", r), t.filter(function (e) {
      return "object" === _typeof(e.value);
    }).forEach(function (t) {
      var o = buildRule(t, n);
      t.query ? attachRule(t.query + " { " + o.rule + " }", r) : attachRule(o.rule, r), t.key.startsWith("@keyframes") || e(t.value, o.classname, r, !1);
    });
  },
  prefixProps = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = {
      Webkit: {
        transform: !0,
        transformOrigin: !0,
        transformOriginX: !0,
        transformOriginY: !0,
        backfaceVisibility: !0,
        perspective: !0,
        perspectiveOrigin: !0,
        transformStyle: !0,
        transformOriginZ: !0,
        animation: !0,
        animationDelay: !0,
        animationDirection: !0,
        animationFillMode: !0,
        animationDuration: !0,
        animationIterationCount: !0,
        animationName: !0,
        animationPlayState: !0,
        animationTimingFunction: !0,
        appearance: !0,
        userSelect: !0,
        fontKerning: !0,
        textEmphasisPosition: !0,
        textEmphasis: !0,
        textEmphasisStyle: !0,
        textEmphasisColor: !0,
        boxDecorationBreak: !0,
        clipPath: !0,
        maskImage: !0,
        maskMode: !0,
        maskRepeat: !0,
        maskPosition: !0,
        maskClip: !0,
        maskOrigin: !0,
        maskSize: !0,
        maskComposite: !0,
        mask: !0,
        maskBorderSource: !0,
        maskBorderMode: !0,
        maskBorderSlice: !0,
        maskBorderWidth: !0,
        maskBorderOutset: !0,
        maskBorderRepeat: !0,
        maskBorder: !0,
        maskType: !0,
        textDecorationStyle: !0,
        textDecorationSkip: !0,
        textDecorationLine: !0,
        textDecorationColor: !0,
        filter: !0,
        fontFeatureSettings: !0,
        breakAfter: !0,
        breakBefore: !0,
        breakInside: !0,
        columnCount: !0,
        columnFill: !0,
        columnGap: !0,
        columnRule: !0,
        columnRuleColor: !0,
        columnRuleStyle: !0,
        columnRuleWidth: !0,
        columns: !0,
        columnSpan: !0,
        columnWidth: !0,
        flex: !0,
        flexBasis: !0,
        flexDirection: !0,
        flexGrow: !0,
        flexFlow: !0,
        flexShrink: !0,
        flexWrap: !0,
        alignContent: !0,
        alignItems: !0,
        alignSelf: !0,
        justifyContent: !0,
        order: !0,
        transition: !0,
        transitionDelay: !0,
        transitionDuration: !0,
        transitionProperty: !0,
        transitionTimingFunction: !0,
        backdropFilter: !0,
        scrollSnapType: !0,
        scrollSnapPointsX: !0,
        scrollSnapPointsY: !0,
        scrollSnapDestination: !0,
        scrollSnapCoordinate: !0,
        shapeImageThreshold: !0,
        shapeImageMargin: !0,
        shapeImageOutside: !0,
        hyphens: !0,
        flowInto: !0,
        flowFrom: !0,
        regionFragment: !0,
        textSizeAdjust: !0
      },
      Moz: {
        appearance: !0,
        userSelect: !0,
        boxSizing: !0,
        textAlignLast: !0,
        textDecorationStyle: !0,
        textDecorationSkip: !0,
        textDecorationLine: !0,
        textDecorationColor: !0,
        tabSize: !0,
        hyphens: !0,
        fontFeatureSettings: !0,
        breakAfter: !0,
        breakBefore: !0,
        breakInside: !0,
        columnCount: !0,
        columnFill: !0,
        columnGap: !0,
        columnRule: !0,
        columnRuleColor: !0,
        columnRuleStyle: !0,
        columnRuleWidth: !0,
        columns: !0,
        columnSpan: !0,
        columnWidth: !0
      },
      ms: {
        flex: !0,
        flexBasis: !1,
        flexDirection: !0,
        flexGrow: !1,
        flexFlow: !0,
        flexShrink: !1,
        flexWrap: !0,
        alignContent: !1,
        alignItems: !1,
        alignSelf: !1,
        justifyContent: !1,
        order: !1,
        transform: !0,
        transformOrigin: !0,
        transformOriginX: !0,
        transformOriginY: !0,
        userSelect: !0,
        wrapFlow: !0,
        wrapThrough: !0,
        wrapMargin: !0,
        scrollSnapType: !0,
        scrollSnapPointsX: !0,
        scrollSnapPointsY: !0,
        scrollSnapDestination: !0,
        scrollSnapCoordinate: !0,
        touchAction: !0,
        hyphens: !0,
        flowInto: !0,
        flowFrom: !0,
        breakBefore: !0,
        breakAfter: !0,
        breakInside: !0,
        regionFragment: !0,
        gridTemplateColumns: !0,
        gridTemplateRows: !0,
        gridTemplateAreas: !0,
        gridTemplate: !0,
        gridAutoColumns: !0,
        gridAutoRows: !0,
        gridAutoFlow: !0,
        grid: !0,
        gridRowStart: !0,
        gridColumnStart: !0,
        gridRowEnd: !0,
        gridRow: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnGap: !0,
        gridRowGap: !0,
        gridArea: !0,
        gridGap: !0,
        textSizeAdjust: !0
      }
    }, e.exports = t.default;
  }),
  capitalizeString = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }, e.exports = t.default;
  }),
  isPrefixedProperty = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return null !== e.match(/^(Webkit|Moz|O|ms)/);
    }, e.exports = t.default;
  }),
  sortPrefixedStyle_1 = createCommonjsModule(function (e, t) {
    function n(e) {
      return Object.keys(e).sort(function (e, t) {
        return (0, o.default)(e) && !(0, o.default)(t) ? -1 : !(0, o.default)(e) && (0, o.default)(t) ? 1 : 0;
      }).reduce(function (t, n) {
        return t[n] = e[n], t;
      }, {});
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    var r = isPrefixedProperty,
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    e.exports = t.default;
  }),
  position_1 = createCommonjsModule(function (e, t) {
    function n(e, t) {
      if ("position" === e && "sticky" === t) return {
        position: ["-webkit-sticky", "sticky"]
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n, e.exports = t.default;
  }),
  joinPrefixedValue = createCommonjsModule(function (e, t) {
    function n(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e, t) {
      var r = arguments.length <= 2 || void 0 === arguments[2] ? function (e, t) {
        return e + t;
      } : arguments[2];
      return n({}, e, ["-webkit-", "-moz-", ""].map(function (e) {
        return r(e, t);
      }));
    }, e.exports = t.default;
  }),
  isPrefixedValue = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return Array.isArray(e) && (e = e.join(",")), null !== e.match(/-webkit-|-moz-|-ms-/);
    }, e.exports = t.default;
  }),
  calc_1 = createCommonjsModule(function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if ("string" == typeof t && !(0, l.default)(t) && t.indexOf("calc(") > -1) return (0, i.default)(e, t, function (e, t) {
        return t.replace(/calc\(/g, e + "calc(");
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var o = joinPrefixedValue,
      i = n(o),
      a = isPrefixedValue,
      l = n(a);
    e.exports = t.default;
  }),
  cursor_1 = createCommonjsModule(function (e, t) {
    function n(e, t) {
      if ("cursor" === e && i[t]) return (0, o.default)(e, t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    var r = joinPrefixedValue,
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r),
      i = {
        "zoom-in": !0,
        "zoom-out": !0,
        grab: !0,
        grabbing: !0
      };
    e.exports = t.default;
  }),
  flex_1 = createCommonjsModule(function (e, t) {
    function n(e, t) {
      if ("display" === e && r[t]) return {
        display: ["-webkit-box", "-moz-box", "-ms-" + t + "box", "-webkit-" + t, t]
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    var r = {
      flex: !0,
      "inline-flex": !0
    };
    e.exports = t.default;
  }),
  sizing_1 = createCommonjsModule(function (e, t) {
    function n(e, t) {
      if (i[e] && a[t]) return (0, o.default)(e, t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    var r = joinPrefixedValue,
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r),
      i = {
        maxHeight: !0,
        maxWidth: !0,
        width: !0,
        height: !0,
        columnWidth: !0,
        minWidth: !0,
        minHeight: !0
      },
      a = {
        "min-content": !0,
        "max-content": !0,
        "fill-available": !0,
        "fit-content": !0,
        "contain-floats": !0
      };
    e.exports = t.default;
  }),
  gradient_1 = createCommonjsModule(function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t) {
      if ("string" == typeof t && !(0, l.default)(t) && null !== t.match(u)) return (0, i.default)(e, t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var o = joinPrefixedValue,
      i = n(o),
      a = isPrefixedValue,
      l = n(a),
      u = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
    e.exports = t.default;
  }),
  uppercasePattern = /[A-Z]/g,
  msPattern = /^ms-/,
  cache$1 = {},
  index$2 = hyphenateStyleName,
  transition_1 = createCommonjsModule(function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function o(e, t) {
      if ("string" == typeof t && m[e]) {
        var n,
          o = i(t),
          a = o.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (e) {
            return null === e.match(/-moz-|-ms-/);
          }).join(",");
        return e.indexOf("Webkit") > -1 ? r({}, e, a) : (n = {}, r(n, "Webkit" + (0, f.default)(e), a), r(n, e, o), n);
      }
    }
    function i(e) {
      if ((0, s.default)(e)) return e;
      var t = e.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
      return t.forEach(function (e, n) {
        t[n] = Object.keys(p.default).reduce(function (t, n) {
          var r = "-" + n.toLowerCase() + "-";
          return Object.keys(p.default[n]).forEach(function (n) {
            var o = (0, l.default)(n);
            e.indexOf(o) > -1 && "order" !== o && (t = e.replace(o, r + o) + "," + t);
          }), t;
        }, e);
      }), t.join(",");
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var a = index$2,
      l = n(a),
      u = capitalizeString,
      f = n(u),
      c = isPrefixedValue,
      s = n(c),
      d = prefixProps,
      p = n(d),
      m = {
        transition: !0,
        transitionProperty: !0,
        WebkitTransition: !0,
        WebkitTransitionProperty: !0
      };
    e.exports = t.default;
  }),
  flexboxIE_1 = createCommonjsModule(function (e, t) {
    function n(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function r(e, t) {
      if (i[e]) return n({}, i[e], o[t] || t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var o = {
        "space-around": "distribute",
        "space-between": "justify",
        "flex-start": "start",
        "flex-end": "end"
      },
      i = {
        alignContent: "msFlexLinePack",
        alignSelf: "msFlexItemAlign",
        alignItems: "msFlexAlign",
        justifyContent: "msFlexPack",
        order: "msFlexOrder",
        flexGrow: "msFlexPositive",
        flexShrink: "msFlexNegative",
        flexBasis: "msPreferredSize"
      };
    e.exports = t.default;
  }),
  flexboxOld_1 = createCommonjsModule(function (e, t) {
    function n(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function r(e, t) {
      return "flexDirection" === e && "string" == typeof t ? {
        WebkitBoxOrient: t.indexOf("column") > -1 ? "vertical" : "horizontal",
        WebkitBoxDirection: t.indexOf("reverse") > -1 ? "reverse" : "normal"
      } : i[e] ? n({}, i[e], o[t] || t) : void 0;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var o = {
        "space-around": "justify",
        "space-between": "justify",
        "flex-start": "start",
        "flex-end": "end",
        "wrap-reverse": "multiple",
        wrap: "multiple"
      },
      i = {
        alignItems: "WebkitBoxAlign",
        justifyContent: "WebkitBoxPack",
        flexWrap: "WebkitBoxLines"
      };
    e.exports = t.default;
  }),
  prefixAll_1 = createCommonjsModule(function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function r(e) {
      return Object.keys(e).forEach(function (t) {
        var n = e[t];
        n instanceof Object && !Array.isArray(n) ? e[t] = r(n) : Object.keys(a.default).forEach(function (r) {
          a.default[r][t] && (e[r + (0, u.default)(t)] = n);
        });
      }), Object.keys(e).forEach(function (t) {
        [].concat(e[t]).forEach(function (n, r) {
          A.forEach(function (r) {
            return o(e, r(t, n));
          });
        });
      }), (0, c.default)(e);
    }
    function o(e) {
      var t = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
      Object.keys(t).forEach(function (n) {
        var r = e[n];
        Array.isArray(r) ? [].concat(t[n]).forEach(function (t) {
          var o = r.indexOf(t);
          o > -1 && e[n].splice(o, 1), e[n].push(t);
        }) : e[n] = t[n];
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var i = prefixProps,
      a = n(i),
      l = capitalizeString,
      u = n(l),
      f = sortPrefixedStyle_1,
      c = n(f),
      s = position_1,
      d = n(s),
      p = calc_1,
      m = n(p),
      y = cursor_1,
      b = n(y),
      g = flex_1,
      v = n(g),
      h = sizing_1,
      x = n(h),
      j = gradient_1,
      k = n(j),
      S = transition_1,
      C = n(S),
      O = flexboxIE_1,
      _ = n(O),
      P = flexboxOld_1,
      w = n(P),
      A = [d.default, m.default, b.default, x.default, k.default, C.default, _.default, w.default, v.default];
    e.exports = t.default;
  }),
  _static = prefixAll_1,
  splitDeclarations = function splitDeclarations(e) {
    return Object.keys(e).map(function (t) {
      return {
        key: convertToKebabCase(t),
        value: e[t]
      };
    });
  },
  flattenArrays = function e(t) {
    return t.reduce(function (t, n) {
      return t.concat(isArray(n) ? e(n) : n);
    }, []);
  },
  handleArrays = function e(t) {
    return t.map(function (t) {
      return isArray(t.value) ? t.value.every(function (e) {
        return "string" == typeof e;
      }) ? t.value.map(function (e) {
        return {
          key: t.key,
          value: e
        };
      }) : t.value.map(function (t) {
        return e(splitDeclarations(t));
      }) : t;
    });
  },
  handleRecursion = function handleRecursion(e) {
    return e.map(function (e) {
      return "object" !== _typeof(e.value) ? e : {
        key: e.key,
        value: formatRule(e.value)
      };
    });
  },
  handleMediaQueries = function handleMediaQueries(e) {
    var t = function t(e) {
      return e.startsWith("@media");
    };
    return e.some(function (e) {
      return t(e.key);
    }) ? e.map(function (e) {
      if (!t(e.key)) return e;
      return {
        key: e.key,
        value: function t(n) {
          return n.map(function (n) {
            return "object" === _typeof(n.value) ? {
              key: n.key,
              value: t(n.value),
              query: e.key
            } : n;
          });
        }(e.value)
      };
    }) : e;
  },
  formatRule = function formatRule(e) {
    return [e].map(_static).map(splitDeclarations).map(handleArrays).map(flattenArrays).map(handleRecursion).map(handleMediaQueries)[0];
  },
  cache = [],
  vuduSheet = createSheet("vSheet"),
  buildRuleset = function buildRuleset(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = "function" == typeof n.suffix ? n.suffix() : n.suffix,
      o = Object.keys(e).map(function (t) {
        return {
          classname: t,
          vuduClass: t + "-" + (r || index$1()),
          styles: e[t]
        };
      });
    return o.forEach(function (e) {
      return addRule(formatRule(e.styles), e.vuduClass, t, !0);
    }), o.reduce(function (e, t) {
      return _extends({}, e, defineProperty({}, t.classname, t.vuduClass));
    }, {});
  },
  v = function v(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = cache.find(function (t) {
        return index(t.element, e);
      });
    if (r) return r.classes;
    var o = t || vuduSheet,
      i = buildRuleset(e, o, n),
      a = {};
    return a.element = e, a.classes = i, cache.push(a), i;
  },
  addFontFace = function addFontFace(e, t) {
    var n = t || vuduSheet,
      r = formatRule(e).map(function (e) {
        return e.key + ": " + e.value;
      }).join(";");
    return attachRule("@font-face { " + r + "; }", n), e.fontFamily.toString();
  },
  logOutput = function logOutput() {
    var e = vuduSheet.cssRules;
    console.log(Object.keys(e).map(function (t) {
      return e[t].cssText;
    }).join("\n\n"));
  },
  options = function options(e) {
    return function (t, n) {
      return v(t, n, e);
    };
  };
v.addFontFace = addFontFace, v.logOutput = logOutput, v.composes = composes, v.config = config, v.options = options, v.v = v, module.exports = v;